import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';

import { TooltipDirective, TooltipOverflowDirective } from '@ideals/ui-components/tooltip';

import { IVideo } from '../../models/interfaces';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TooltipDirective, TooltipOverflowDirective],
  selector: 'ideals-help-video-item',
  styleUrls: ['./help-video-item.component.scss'],
  templateUrl: './help-video-item.component.html',
})
export class HelpVideoItemComponent {
  readonly video = input<IVideo>();

  readonly openVideo = output<IVideo>();

  onVideoClick(event: MouseEvent): void {
    event?.preventDefault();
    this.openVideo.emit(this.video());
  }
}
